import { isMobileOnly } from 'react-device-detect';


export const toggleDesktopMode = () => {
    const metaViewport: HTMLMetaElement | null = document.querySelector("meta[name='viewport']");
    if (!metaViewport) return;
    if (isMobileOnly) {
        metaViewport.content = "width=device-width, initial-scale=1.0";
    } else {
        metaViewport.content = "width=1024";
    }
}